import apiConfig from './apiConfig';

const apiUrl = apiConfig.configApiUrl;
const options = (method, body) => apiConfig.configOptions(method, body);
const callApi = (_url, _options) => apiConfig.configCallApi(_url, _options);

//=================== Auth API =============================//
const login = async (username, password) => {
    //Username[email]
    const url = apiUrl + `/users/login`;
    var resp = await callApi(url, options('POST', { username, password }));

    return resp;
};

const signup = async (body) => {
    //Username[email]
    console.log(body);
    const url = apiUrl + `/signup`;
    var resp = await callApi(url, options('POST', body));

    return resp;
};

const forgetPassword = async (email) => {
    //Username[email] ==> Generate resetKey and send to email reset link
    const url = apiUrl + `/reset-password/init`;
    console.log('email:', email);
    var resp = await callApi(url, options('POST', { email: email }));

    return resp;
};

const resetPassword = async (resetKey, password, confirmPassword) => {
    //Username[email]
    const url = apiUrl + `/reset-password/finish`;
    var resp = await callApi(
        url,
        options('PUT', { resetKey: resetKey, password: password, confirmPassword: confirmPassword })
    );

    return resp;
};

const resetPasswordAdmin = async (userId, oldPassword, newPassword) => {
    //Username[email]
    const url = apiUrl + `/users/${userId}`;
    var resp = await callApi(url, options('PATCH', { oldPassword: oldPassword, newPassword: newPassword }));

    return resp;
};

const resetPasswordUserByAdmin = async (userId, newPassword) => {
    //Username[email]
    const url = apiUrl + `/users/${userId}`;
    var resp = await callApi(url, options('PATCH', { newPassword: newPassword }));

    return resp;
};

const changeEmailUserByAdmin = async (userId, email) => {
    //Username[email]
    const url = apiUrl + `/users/${userId}`;
    var resp = await callApi(url, options('PATCH', { email: email, username: email }));

    return resp;
};

const deleteUserAuth = async (userId) => {
    const url = apiUrl + `/users/${userId}`;
    var resp = await callApi(url, options('DELETE'));

    return resp;
};

export default {
    //AUTH API
    login,
    signup,
    forgetPassword,
    resetPassword,
    resetPasswordAdmin,
    resetPasswordUserByAdmin,
    changeEmailUserByAdmin,
    deleteUserAuth,
};
